import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const CustomButton = styled(Button)(({ theme }) => ({
  color: "white",
  fontSize: "1rem",
  bordeRadius: "6px",
  boxShadow: "0px 3px 8px rgba(0, 123, 255, 0.3)",
  background: "linear-gradient(to right, #007BFF, #0056D2)",
  "&:hover": {
    background: "linear-gradient(to right, #0056D2, #003DA6)",
  },
}));
